import { ROLES } from '../types/roles';

export const hasDistriAccess = (role?: ROLES) => {
  if (!role) {
    return false;
  }
  const distriRoles = [ROLES.ADMIN, ROLES.DISTRI];
  return distriRoles.includes(role);
};

export const hasAdminAccess = (role?: ROLES) => {
  if (!role) {
    return false;
  }
  const adminRoles = [ROLES.ADMIN];
  return adminRoles.includes(role);
};
